import { createContext, useContext, useState, useCallback } from "react";

/**
 * VendorStoreContext — holds the vendor whose slug URL is currently being visited.
 *
 * null  = normal platform mode (no vendor slug in URL)
 * {...} = user opened /:storeSlug — the entire app becomes that vendor's branded store
 */
const VendorStoreContext = createContext({
  vendorStore: null,   // vendor object when on /:storeSlug pages, else null
  storeSlug: null,     // the slug string
  _setVendorStore: () => {},
});

export function VendorStoreProvider({ children }) {
  const [state, setState] = useState({ vendorStore: null, storeSlug: null });

  const _setVendorStore = useCallback((updates) => {
    setState((prev) => ({ ...prev, ...updates }));
  }, []);

  return (
    <VendorStoreContext.Provider value={{ ...state, _setVendorStore }}>
      {children}
    </VendorStoreContext.Provider>
  );
}

export const useVendorStore = () => useContext(VendorStoreContext);
